/* BA Mystery Necklace GWP disabled by request. No auto-add, no cart changes. */
(function(){ window.__baGwpMinimalV2Loaded = true; window.__baGwpMinimalLoaded = true; })();
